import {Component, HostBinding, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import { ReportPageInterface } from 'src/app/interface';
import { FieldValue, FieldValueReset, Report, Risk } from 'src/app/model';
import { CustomersCount, FooterButtonOption, PageNumbers, SalesPercent, YesNo } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import { radioGroupOption } from '../../commonModel/common-classes';
import {routeTransition} from '../../../../animations/route-transition';

@Component({
  selector: 'app-diversification',
  templateUrl: './diversification.component.html',
  styleUrls: ['./diversification.component.scss'],
  animations: [routeTransition],
})
export class DiversificationComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  @ViewChild('diversificationForm') diversificationForm: NgForm;

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  //#region "customers-amount"
  customersCountList: radioGroupOption[] = [];
  //#endregion

  //#region "div15-annual-revenue"
  singleClientPerList: radioGroupOption[] = [];
  //#endregion

  //#region "div50-annual-revenue"
  yesNoList: radioGroupOption[] = [];
  salesPercentList: radioGroupOption[] = [];
  //#endregion

  constructor(private reportService: ReportService,
    private reportProvider: ReportProvider,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {

    //#region "customers-amount"
    this.customersCountList.push({ title: '1 – 5', value: CustomersCount._1_TO_5 });
    this.customersCountList.push({ title: '6 – 10', value: CustomersCount._6_TO_10 });
    this.customersCountList.push({ title: '11 – 25', value: CustomersCount._11_TO_25 });
    this.customersCountList.push({ title: '26 – 100', value: CustomersCount._26_TO_100 });
    this.customersCountList.push({ title: 'Too many to count', value: CustomersCount.TOO_MANY_TO_COUNT });
    //#endregion

    //#region "div15-annual-revenue"
    this.singleClientPerList.push({ title: 'Yes', value: YesNo.YES });
    this.singleClientPerList.push({ title: 'No', value: YesNo.NO });
    //#endregion

    //#region "div50-annual-revenue"
    this.yesNoList.push({ title: 'Yes', value: YesNo.YES });
    this.yesNoList.push({ title: 'No', value: YesNo.NO });

    this.salesPercentList.push({ title: '50 – 75%', value: SalesPercent._50_TO_75_PERCENT });
    this.salesPercentList.push({ title: '76 – 100%', value: SalesPercent._76_TO_100_PERCENT });
    //#endregion

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport && this.currentReport.LATEST) {
      if (!this.currentReport.LATEST.RISK) {
          this.createNewRiskObject();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description create risk object if not exists
   */
  createNewRiskObject() {
    this.reportProvider.createRisk(this.currentReport.LATEST.ID, new Risk()).subscribe(resp => {
      if (resp.success) {
        this.currentReport.LATEST.RISK = resp.result;
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description field update API
   */
  callUpdateAPI(fieldName: string) {

    setTimeout(() => {
      this.autoScroll(fieldName);
    }, 10);

    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST.RISK[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  autoScroll(fieldName: string) {
    switch (fieldName) { // for auto focus and auto scroll
      case 'DIV_CUSTOMERS':
        this.reportService.makeElementFocus('single-client-percent-type-radio-group-yes');
        break;
      case 'DIV_SINGLE_CLIENT_PERCENT':
        this.reportService.makeElementFocus('risk-div-more-fifty-type-radio-group-yes');
        break;
      case 'DIV_MORE_FIFTY':
        if (this.currentReport.LATEST.RISK.DIV_MORE_FIFTY === YesNo.YES) {
          this.reportService.makeElementFocus('risk-div-sales-percent-type-radio-group-50-–-75%');
        } else if (this.currentReport.LATEST.RISK.DIV_MORE_FIFTY === YesNo.NO) {
          this.reportService.makeElementFocus('risk-div-vendor-percent-type-radio-group-yes');
        }
        break;
      case 'DIV_SALES_PERCENT':
        if (this.currentReport.LATEST.RISK.DIV_SALES_PERCENT) {
          this.reportService.makeElementFocus('risk-div-contracts-type-radio-group-yes');
        }
        break;
      case 'DIV_CONTRACTS':
        if (this.currentReport.LATEST.RISK.DIV_CONTRACTS) {
          this.reportService.makeElementFocus('risk-div-sales-losttype-radio-group-yes');
        }
        break;
      case 'DIV_SALES_LOST':
        this.reportService.makeElementFocus('risk-div-vendor-percent-type-radio-group-yes');
        break;
      case 'DIV_VENDOR_PERCENT':
        if (this.currentReport.LATEST.RISK.DIV_VENDOR_PERCENT === YesNo.YES) {
          this.reportService.makeElementFocus('risk-div-similar-vendor-type-radio-group-yes');
        }
        break;
    }
  }

  /**
   * @description field reset API
   */
  resetFieldAPI() {
    this.currentReport.LATEST.RISK.DIV_CUSTOMERS = null;
    this.currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT = null;
    this.currentReport.LATEST.RISK.DIV_MORE_FIFTY = null;
    this.currentReport.LATEST.RISK.DIV_SALES_PERCENT = null;
    this.currentReport.LATEST.RISK.DIV_CONTRACTS = null;
    this.currentReport.LATEST.RISK.DIV_SALES_LOST = null;
    this.currentReport.LATEST.RISK.DIV_VENDOR_PERCENT = null;
    this.currentReport.LATEST.RISK.DIV_SIMILAR_VENDOR = null;
    let objFieldValueReset = new FieldValueReset();
    objFieldValueReset.GROUP = 'RISK';
    objFieldValueReset.FIELD_LIST = [
      'DIV_CUSTOMERS',
      'DIV_SINGLE_CLIENT_PERCENT',
      'DIV_MORE_FIFTY',
      'DIV_SALES_PERCENT',
      'DIV_CONTRACTS',
      'DIV_SALES_LOST',
      'DIV_VENDOR_PERCENT',
      'DIV_SIMILAR_VENDOR'
    ];
    this.reportProvider.resetReportField(this.currentReport.LATEST.ID, objFieldValueReset).subscribe(res => {
      if (res.success) {
        document.getElementById('reportPart').scrollTo(0, 0);
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });

  }

  showHideDiversification() {
    this.currentReport.LATEST.RISK.OPT_DV = !this.currentReport.LATEST.RISK.OPT_DV;
    let fieldName = 'OPT_DV';
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST.RISK[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for scroll focuse on inputs
   * @param $event key down
   */
  @HostListener('window:keyup', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if ($event.keyCode == 9) {
      const elePosition = document.activeElement.getBoundingClientRect();
      if (window.innerHeight - 115 < elePosition.y) {
        document.activeElement.scrollIntoView(true);
      }
    }
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.diversificationForm.valid || this.currentReport?.isLocked;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.DIVERSIFICATION);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/risk/personal-goodwill`);
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/assets-liabilities`);
    } else if (buttonOption == FooterButtonOption.SKIP_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.DIVERSIFICATION, true);
      this.resetFieldAPI();
    } else if (buttonOption == FooterButtonOption.EXTRA_CLICK) {
      this.showHideDiversification();
    }
  }

}
